import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { hasBlockedExtension } from './attachment-security.utils';

@Injectable({ providedIn: 'root' })
export class FileUtils {

  FromByteArrayToFile(data: ArrayBuffer, fileName: string): File {
    const array = new Uint8Array(data);
    const ext = this.fileExtension(fileName).toLowerCase()
    const blob = new Blob([array], {type: `image/${ext}`});
    return this.blobToFile(blob, fileName)
  }

  blobToFile = (theBlob: Blob, fileName:string): File => {
    var b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    const fl = <File>theBlob
    return fl;
  }

  constructor(
    private sanitizer: DomSanitizer
  ) {}

  isImage(fileName: string){
    return this.fileExtension(fileName).includes('SVG') ||
          this.fileExtension(fileName).includes('PNG') ||
          this.fileExtension(fileName).includes('GIF') ||
          this.fileExtension(fileName).includes('JPG') ||
          this.fileExtension(fileName).includes('JPEG') ||
          this.fileExtension(fileName).includes('HEIC') ||
          this.fileExtension(fileName).includes('HEIF')
          ? true : false
  }

  isPdf(file: File): boolean {
    return file.type === 'application/pdf'
  }

  isImageOrPdf(file: File): boolean {
    return this.isImage(file.name) || this.isPdf(file);
  }

  /**
   * Valida um anexo: a extensão não pode ser perigosa (executáveis, scripts,
   * macros) e o arquivo precisa ser imagem ou PDF.
   * A extensão é verificada antes do tipo, pois o mime type pode ser falsificado.
   */
  isAllowedAttachment(file: File): boolean {
    return !hasBlockedExtension(file.name) && this.isImageOrPdf(file);
  }

  /** Separa os anexos permitidos dos bloqueados. */
  splitAllowedAttachments(files: File[]): { allowed: File[]; blocked: File[] } {
    const allowed: File[] = [];
    const blocked: File[] = [];

    (files ?? []).forEach((file: File) => {
      if (this.isAllowedAttachment(file)) {
        allowed.push(file);
      } else {
        blocked.push(file);
      }
    });

    return { allowed, blocked };
  }

  fileTransformation(response: ArrayBuffer, fileName: string) {
    var byteArray = new Uint8Array(response);
    const STRING_CHAR = byteArray.reduce((data, byte) => {
      return data + String.fromCharCode(byte);
    }, '');
    let base64String = btoa(STRING_CHAR);
    const ext = this.fileExtension(fileName).toLowerCase()
    let imageUrl: string = `data:image/${ext};base64, ${base64String}`;
    let file = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
    return file
  }

  imageTransformation(response: ArrayBuffer) {
    var byteArray = new Uint8Array(response);
    const STRING_CHAR = byteArray.reduce((data, byte) => {
      return data + String.fromCharCode(byte);
    }, '');
    let base64String = btoa(STRING_CHAR);
    let imageUrl: string = 'data:image/jpg;base64, ' + `${base64String}`;
    let file = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
    return file
  }

  pdfTransformation(response: ArrayBuffer) {
    var byteArray = new Uint8Array(response);
    const STRING_CHAR = byteArray.reduce((data, byte) => {
      return data + String.fromCharCode(byte);
    }, '');
    let base64String = btoa(STRING_CHAR);
    let imageUrl: string = 'data:application/pdf;base64, ' + `${base64String}`;
    let file = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
    return file
  }

  fileExtension(fileName: string): string {
    const nameSplited = fileName.split('.')
    return nameSplited[nameSplited.length-1].toUpperCase()
  }

  arrayBufferToBase64( buffer: ArrayBuffer ) {
    const byteArray = new Uint8Array(buffer);
    const STRING_CHAR = byteArray.reduce((data, byte) => {
      return data + String.fromCharCode(byte);
    }, '');
    return btoa(STRING_CHAR);
  }

  sanitize( url:string ) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  validateSize(size: number, testTypePdf: boolean): boolean{
    if(testTypePdf) return true

    const validTypes: string[] = ['Bytes','KB','MB']
    const decimalSize: string[] = this.formatBytes(size).split(' ')

    if(!validTypes.includes(decimalSize[1]))
      return false

    if(decimalSize[1]!=='MB')
      return true

    if(parseFloat(decimalSize[0]) < 10.00){
      return true
    }
    return false
  }

  formatBytes(bytes: number) {
    const decimals = 2
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  formatBytesFromBufferArray(bytes: ArrayBuffer) {
    const decimals = 2
    const size = bytes.byteLength
    if (size === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

}
